var map = {
	"./XugarHero_criticalHigh.svg": "C0lb",
	"./XugarHero_criticalLow.svg": "WRK3",
	"./XugarHero_happy.svg": "ajRe",
	"./XugarHero_warningHigh.svg": "no8f",
	"./XugarHero_warningLow.svg": "cJxL"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "X0Te";


//////////////////
// WEBPACK FOOTER
// ./src/brand/xugarhero/assets/xugarHero ^\.\/XugarHero_.*\.svg$
// module id = X0Te
// module chunks = 1